import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../../environments/environment";
import { Patient } from "./patient.model";
import { HttpClient } from "@angular/common/http";

const API_ENDPOINT = environment.API_ENDPOINT + "/patients";

@Injectable()
export class PatientsService {
  patients: Observable<Array<Patient>>;

  constructor(private http: HttpClient) {}

  searchPatients(query?: string): Observable<Patient[]> {
    if (query) {
      return this.http.get<Patient[]>(API_ENDPOINT + "?q=" + query);
    } else {
      return this.http.get<Patient[]>(API_ENDPOINT);
    }
  }

  getPatient(patient: Patient): Observable<Patient> {
    return this.http.get<Patient>(API_ENDPOINT + "/" + patient.id);
  }

  createPatient(patient: Patient): Observable<Patient> {
    return this.http.post<Patient>(API_ENDPOINT, patient);
  }

  updatePatient(patient: Patient): Observable<Patient> {
    return this.http.put<Patient>(API_ENDPOINT + "/" + patient.id, patient);
  }

  deletePatient(patient: Patient): Observable<Patient> {
    return this.http.delete<Patient>(API_ENDPOINT + "/" + patient.id);
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/patient/patient.service.ts